export default {
  pageText: "{0} es",
  noDataText: "No data available",
  appBar: {
    siteTitle: "Desarrollo en primera persona",
    siteTitleCorp: "Strickland Software Engineering Corp.",
    siteTitleCorpSmall: "Strickland Software",
    projects: "projects",
  },
  banner: {
    iosDescription:
      "Desarrollo de aplicaciones para dispositivos móviles y Apple TV",
    androidDescription:
      "Desarrollo en Android para todo tipo de dispositivos móviles y TV",
    serverDescription:
      "Desarrollo de API de servidor para aplicaciones móviles y más",
  },
  detail: {
    privacyPolicy: "Política de privacidad",
    terms: "Términos de uso",
  },
  appList: {
    moreDetailed: "Detallado...",
  },
  messageForm: {
    messageTitle: "Mensaje al desarrollador",
    message: "Mensaje",
    messageSuccess: "Mensaje enviado",
    isRequired: "El campo debe estar lleno",
    mustBeLess: "El campo no debe contener más de {0} caracteres",
    incorrectEmail: "Introduzca el correo electrónico correcto",
    sendButton: "Enviar",
    appField: "Aplicación",
    nameField: "Nombre",
    emailField: "Email",
  },
  not_found_component: {
    go_home: "Inicio",
    description: "Ooops... Error 404 Lo sentimos, pero la página que buscas no existe."

  }
};
